<template>
    <div class="mobile-controls">
        <template v-if="!showStartPage">
            <transition name="prevButton" appear>
                <button v-if="currentPanel > 0 && currentPanel < 3"
                        class="button button--primary button--border button--prev button--arrow button--arrow-prev button--arrow-centered"
                        @click="previousPanel">
                </button>
            </transition>
            <transition name="mainButton" appear>
                <button v-if="currentPanel < 3"
                        class="panel-control button button--secondary"
                        @click="toggleMobilePanel"
                >
                    <template v-if="mobilePanel">
                        Vorschau
                    </template>
                    <template v-else>
                        <template v-if="currentPanel == 0">
                            Device wählen
                        </template>
                        <template v-if="currentPanel == 1">
                            Muster wählen
                        </template>
                        <template v-if="currentPanel == 2">
                            Kudos
                        </template>
                    </template>
                </button>
            </transition>

            <transition name="nextButton" appear>
                <button v-if="currentPanel < 3"
                        class="button button--secondary button--next button--arrow button--arrow-centered"
                        :class="currentPanel == 2 ? 'button--complete' : ''"
                        @click="nextPanel">
                </button>
            </transition>
        </template>
    </div>
</template>

<script>
    export default {
        props: ['currentPanel', 'mobilePanel', 'showStartPage'],
        methods: {
            nextPanel() {
                this.eventHub.$emit('panelChange', 'next');
            },
            previousPanel() {
                this.eventHub.$emit('panelChange', 'prev');
            },
            toggleMobilePanel() {
                this.$emit('toggleMobilePanel');
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import './../assets/scss/animations/fade';
    @import './../assets/scss/dimensions';

    .mobile-controls {

        @media (min-width: 1024px) {
            display: none;
        }

        .button {
            height: 40px;
            font-family: 'PxGroteskRegular';
            padding: 0;
            position: fixed;
            width: 40px;
            z-index: 100;

            &--prev {
                bottom: 16px;
                left: $brand-size-x;
            }

            &--next {
                bottom: 16px;
                right: $brand-size-x;
            }

        }

        .panel-control {
            position: fixed;
            left: 50%;
            bottom: 16px;
            padding: 0 24px 2px 24px;
            transform: translateX(-50%);
            width: auto;

        }
    }

    .mainButton-enter-active {
        animation: fadeInFromBottomCentered .25s ease-in-out forwards;
    }

    .mainButton-leave-active {
        animation: fadeOutToBottomCentered .25s ease-in-out forwards;
    }

    .nextButton-enter-active {
        animation: fadeInFromRight .25s ease-in-out forwards;
    }

    .nextButton-leave-active {
        animation: fadeOutToRight .25s ease-in-out forwards;
    }

    .prevButton-enter-active {
        animation: fadeInFromLeft .25s ease-in-out forwards;
    }

    .prevButton-leave-active {
        animation: fadeOutToLeft .25s ease-in-out forwards;
    }

</style>


// WEBPACK FOOTER //
// src/components/MobileNavigation.vue